import { render } from "./cemsPreAlarm.vue?vue&type=template&id=488a84d5"
import script from "./cemsPreAlarm.vue?vue&type=script&lang=js"
export * from "./cemsPreAlarm.vue?vue&type=script&lang=js"

import "./cemsPreAlarm.vue?vue&type=style&index=0&id=488a84d5&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__